import { h } from 'preact';
import { useMemo } from 'preact/hooks';
import { formatMoney } from 'utils/storefront/format-resource';
import CheckMarkIcon from 'utils/icon/icon-checkmark.svg';
import clsx from 'clsx';
import { withCartContext } from './cart-context';

const CartThreshold = ({
  cart,
  active,
  threshold,
  beforeMessage,
  afterMessage,
}) => {
  if (!active) {
    return null;
  }

  const { message, percent } = useMemo(() => {
    if (cart.state.total_price >= threshold * 100) {
      return {
        message: afterMessage,
        percent: 100,
      };
    }
    return {
      message: beforeMessage.replace(
        '[amount]',
        formatMoney({ amount: threshold * 100 - cart.state.total_price }, true),
      ),
      percent: (cart.state.total_price / (threshold * 100)) * 100,
    };
  }, [cart.state, threshold]);
  return (
    <div className="pt-8 pb-32">
      <div
        className="body-3 mb-8 ml:mb-16 ml:text-center"
        data-target="text-content"
        dangerouslySetInnerHTML={{ __html: message }}
      ></div>
      <div
        className={clsx('h-6 rounded-40 relative', {
          'border border-grey-900': percent !== 100,
        })}
      >
        <div
          className={clsx('h-full  rounded-40', {
            'bg-misc-green': percent === 100,
            'bg-grey-900': percent !== 100,
          })}
          style={{ width: `${percent}%` }}
        ></div>
        {percent === 100 && (
          <div className="absolute -right-2 top-0 p-1 bg-misc-green rounded-full text-white -mt-6">
            <CheckMarkIcon className="h-14 w-14" />
          </div>
        )}
      </div>
    </div>
  );
};

export default withCartContext(CartThreshold);
